import { useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import ensightLogo from '../assets/ensight-logo.png'
import { useAuth } from '../components/AuthProvider.jsx'

export default function LoginPage() {
  const { isAuthenticated, authReady, login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [remember, setRemember] = useState(true)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  if (!authReady) {
    return <div className="app-loading">불러오는 중...</div>
  }

  if (isAuthenticated) {
    return <Navigate to={location.state?.from || '/'} replace />
  }

  async function handleSubmit(event) {
    event.preventDefault()
    setError('')
    if (!username.trim() || !password) {
      setError('아이디와 비밀번호를 입력해 주세요.')
      return
    }
    setLoading(true)
    try {
      await login({ username, password, remember })
      navigate(location.state?.from || '/', { replace: true })
    } catch (err) {
      setError(err.message || '아이디 또는 비밀번호를 확인해주세요.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <p className="login-kicker">
          <img className="login-kicker__logo" src={ensightLogo} alt="" />
          사내 전용
        </p>
        <h1>ENSIGHT 재고관리시스템</h1>
        <p className="login-lead">공장·사무실에서 부품 재고와 입출고를 관리합니다.</p>

        <label className="field">
          <span>아이디</span>
          <input
            className="input"
            name="username"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>
        <label className="field">
          <span>비밀번호</span>
          <input
            className="input"
            name="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <label className="check">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
          로그인 상태 유지
        </label>

        {error ? <p className="form-error">{error}</p> : null}

        <button type="submit" className="btn btn--primary btn--touch login-submit" disabled={loading}>
          {loading ? '확인 중...' : '로그인'}
        </button>
      </form>
    </div>
  )
}
